import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

export const globalControlReportNRO: NavigationRoutingObject = {
  section: "analytics",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("global-control-report-sidebar-pill-menu-option", "Global Control Group Report"),
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [t("global-control", "Global Control")],
      description: t("previously-global-control", 'Previously "Global Control"'),
    },
  ],
  additionalSearchableFeatures: () => ({}),
};
